import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import StatusBadge from './StatusBadge';

const Menu = ({ id }) => (
    <div className="dropdown">
        <a className="btn btn-sm btn-icon-only text-light"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <i className="fas fa-ellipsis-v" />
        </a>
        <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
            <Link className="dropdown-item" to={`/usuarios/${id}`}>Detalhes</Link>
            <Link className="dropdown-item" to={`/usuarios/editar/${id}`}>Editar</Link>
        </div>
    </div>
);

const Media = ({ photo, id, name }) => (
    <div className="media align-items-center">
        <Link to={`/usuarios/${id}`} className="avatar rounded-circle mr-3">
            <img alt={`Foto de ${name}`} src={photo} />
        </Link>
        <div className="media-body">
            <span className="mb-0 text-sm">{name}</span>
        </div>
    </div>
);

const Permission = ({ permission }) => {
    const permissions = {
        'ADMIN': 'Admininstrador(a)',
        'SELLER': 'Atendente',
        'COMMON': 'Visualizador(a)',
        'SUPERVISOR': 'Supervisor(a)'
    };
    const title = permissions[permission] || 'Outra';
    return <span>{title}</span>;
}

export default class TableRow extends Component {
    render() {
        const { id, permission, user } = this.props;
        const { photo, name, email, phone, createdAt, lastLogin, status } = user;
        return (
            <tr>
                <th scope="row">
                    <Media id={id} name={name} photo={photo} />
                </th>
                <td>{email}</td>
                <td>{phone}</td>
                <td>
                    <Permission permission={permission} />
                </td>
                <td>{createdAt}</td>
                <td>{lastLogin}</td>
                <td>
                    <StatusBadge status={status} />
                </td>
                <td className="text-right">
                    <Menu id={id} />
                </td>
            </tr>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Pages/Users/TableRow.js